/**
 * See backend SonPageType.java
 */
export const PageType = {
  accessibilitystatement: 'accessibilitystatement',
  blog: 'blog',
  blogpost: 'blogpost',
  connectedorgunits: 'connectedorgunits',
  connectedtopics: 'connectedtopics',
  contentsearch: 'contentsearch',
  devprototype: 'devprototype',
  document: 'document',
  error: 'error',
  event: 'event',
  eventlist: 'eventlist',
  externallink: 'externallink',
  externalapplication: 'externalapplication',
  faq: 'faq',
  faqlist: 'faqlist',
  faqlistpost: 'faqlistpost',
  forum: 'forum',
  formapplication: 'formapplication',
  gvpPrint: 'gvpPrint',
  forumthread: 'forumthread',
  help: 'help',
  institution: 'institution',
  imagegallery: 'imagegallery',
  legalnotice: 'legalnotice',
  location: 'location',
  locationhome: 'locationhome',
  members: 'members',
  newsletter: 'newsletter',
  node: 'node',
  nodehome: 'nodehome',
  orgunit: 'orgunit',
  orgunithome: 'orgunithome',
  pagelist: 'pagelist',
  pagelistatoz: 'pagelistatoz',
  pagelisttable: 'pagelisttable',
  pagelistteaser: 'pagelistteaser',
  childpages: 'childpages',
  personalprofile: 'personalprofile',
  personsearch: 'personsearch',
  portalconfiguration: 'portalconfiguration',
  poll: 'poll',
  survey: 'survey',
  privacypolicy: 'privacypolicy',
  process: 'process',
  processhome: 'processhome',
  passwordforgot: 'passwordforgot',
  passwordreset: 'passwordreset',
  smashdocs: 'smashdocs',
  structurediagram: 'structurediagram',
  task: 'task',
  teamroom: 'teamroom',
  termsofservice: 'termsofservice',
  ticketbooking: 'ticketbooking',
  topic: 'topic',
  topichome: 'topichome',
  userregistration: 'userregistration',
  userregistrationform: 'userregistrationform',
  wiki: 'wiki',
  wikihome: 'wikihome',
  sharedfileshome: 'sharedfileshome',
  sharedfilesdirectory: 'sharedfilesdirectory',
  signlanguage: 'signlanguage',
  simplelanguage: 'simplelanguage',
  globalpagetrash: 'globalpagetrash',
} as const;
export type PageType = (typeof PageType)[keyof typeof PageType];
